export default __webpack_public_path__ + "images/gs-c19adcdd5855af626a3c70ddc50f6690.svg";